import React, { Component } from 'react';

class Loader extends Component {
  render() {
    return (
      <div className={ `loader ${this.props.className}` }>
        <svg className="spinner" viewBox="0 0 50 50">
          <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="3"></circle>
        </svg>
      </div>
    );
  }
}

export default Loader;
